const field = () => import('@/m-common/demo/field-demo');
const field2 = () => import('@/m-common/demo/field-demo2');
const detail = () => import('@/m-common/demo/detail-demo');
const search = () => import('@/m-common/demo/search-demo');
const demoNav = () => import('@/m-common/demo/index');
const indexTemplate = () => import('@/m-common/template/indexTemplate');
const indexTemplateDetail = () => import('@/m-common/template/indexTemplate/detail');
const indexTemplate_noFilters = () => import('@/m-common/template/indexTemplate_noFilters');
const indexTemplate_noTags = () => import('@/m-common/template/indexTemplate_noTags');
const indexTemplate_noTagsfilter = () => import('@/m-common/template/indexTemplate_noTagsfilter');
export default [
  {
    path: '/demo/field',
    name: 'demofield',
    component: field,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/field2',
    name: 'demofield2',
    component: field2,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/index',
    name: 'demoNav',
    component: demoNav,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/detail',
    name: 'demodetail',
    component: detail,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/search',
    name: 'demosearch',
    component: search,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/indexTemplate',
    name: 'indexTemplate',
    component: indexTemplate,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/indexTemplateDetail',
    name: 'indexTemplateDetail',
    component: indexTemplateDetail,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/indexTemplate_noFilters',
    name: 'indexTemplate_noFilters',
    component: indexTemplate_noFilters,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/indexTemplate_noTags',
    name: 'indexTemplate_noTags',
    component: indexTemplate_noTags,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/indexTemplate_noTagsfilter',
    name: 'indexTemplate_noTagsfilter',
    component: indexTemplate_noTagsfilter,
    meta: {
      permissionValue: '*'
    }
  },
  {
    path: '/demo/DstFilter',
    name: '/demo/DstFilter',
    component: () => import('@/m-common/components/DstFilter/use'),
  }, {
    path: '/demo/DstField',
    name: '/demo/DstField',
    component: () => import('@/m-common/components/DstField/use'),
  },
  {
    path: '/demo/DstRemoteSearch',
    name: '/demo/DstRemoteSearch',
    component: () => import('@/m-common/components/DstRemoteSearch/use.vue'),
  }
];



// WEBPACK FOOTER //
// ./src/m-common/demo/router/index.js